export const accountTypeConstants = {
    customer: 1,
    contractor: 2
};